import { ReactComponent as SuperchargeYourLife } from '../assets/svg/SuperchargeYourLife.svg';
import { ReactComponent as MentalMojo } from '../assets/svg/MentalMojo.svg';
import { ReactComponent as HealthHub } from '../assets/svg/HealthHub.svg';
import { ReactComponent as LifeHacks } from '../assets/svg/LifeHacks.svg';
import { ReactComponent as FamilyFusion } from '../assets/svg/FamilyFusion.svg';
import { ReactComponent as SocialSimphony } from '../assets/svg/SocialSimphony.svg';
import { ReactComponent as EduGym } from '../assets/svg/EduGym.svg';
import { ReactComponent as CyberSavvy } from '../assets/svg/CyberSavvy.svg';
import { ReactComponent as CategoryCloud } from '../assets/svg/CategoryCloud.svg';
import { ReactComponent as Wellbeing } from '../assets/svg/Wellbeing.svg';
import { ReactComponent as Academics } from '../assets/svg/Academics.svg';
import { ReactComponent as Relationships } from '../assets/svg/Relationships.svg';
import { ReactComponent as Growth } from '../assets/svg/Growth.svg';
import { ReactComponent as Stress } from '../assets/svg/CategoryCloud.svg';
import { ReactComponent as Goals } from '../assets/svg/Goals.svg';

export function setCourseCategoryIcon(categoryName: string) {
	let icon;

	switch (categoryName) {
		case 'Supercharge Your Life':
			icon = <SuperchargeYourLife />;
			break;
		case 'Mental Mojo':
			icon = <MentalMojo />;
			break;
		case 'Health Hub':
			icon = <HealthHub />;
			break;
		case 'Life Hacks':
			icon = <LifeHacks />;
			break;
		case 'Family Fusion':
			icon = <FamilyFusion />;
			break;
		case 'Social Symphony':
			icon = <SocialSimphony />;
			break;
		case 'Edu Gym':
			icon = <EduGym />;
			break;
		case 'Cyber Savvy':
			icon = <CyberSavvy />;
			break;
		default:
			icon = <CategoryCloud />;
	}

	return icon;
}

export function setSolutionCategoryIcon(categoryName: string) {
	let icon;

	switch (categoryName) {
		case 'Wellbeing':
			icon = <Wellbeing />;
			break;
		case 'Academics':
			icon = <Academics />;
			break;
		case 'Relationships':
			icon = <Relationships />;
			break;
		case 'Growth':
			icon = <Growth />;
			break;
		case 'Stress':
			icon = <Stress />;
			break;
		case 'Goals':
			icon = <Goals />;
			break;
		default:
			icon = <CategoryCloud />;
	}

	return icon;
}
export const locationItemImages: Record<string, any> = {
	airflowControl: require('../assets/images/Journey/B2CImages/airflowControl.png'),
	altitudeMeter: require('../assets/images/Journey/B2CImages/altitudeMeter.png'),
	anchorHooks: require('../assets/images/Journey/B2CImages/anchorHooks.png'),
	basketFrame: require('../assets/images/Journey/B2CImages/basketFrame.png'),
	basketLantern: require('../assets/images/Journey/B2CImages/basketLantern.png'),
	burnerFrame: require('../assets/images/Journey/B2CImages/burnerFrame.png'),
	compass: require('../assets/images/Journey/B2CImages/compass.png'),
	decorativeFlag: require('../assets/images/Journey/B2CImages/decorativeFlag.png'),
	dragonScaleToken: require('../assets/images/Journey/B2CImages/dragonScaleToken.png'),
	fabricSheets: require('../assets/images/Journey/B2CImages/fabricSheets.png'),
	fireproofCloak: require('../assets/images/Journey/B2CImages/fireproofCloak.png'),
	fireproofGloves: require('../assets/images/Journey/B2CImages/fireproofGloves.png'),
	floorPadding: require('../assets/images/Journey/B2CImages/floorPadding.png'),
	friendshipRune: require('../assets/images/Journey/B2CImages/friendshipRune.png'),
	fuel: require('../assets/images/Journey/B2CImages/fuel.png'),
	glowFlowers: require('../assets/images/Journey/B2CImages/glowFlowers.png'),
	heatRegulator: require('../assets/images/Journey/B2CImages/heatRegulator.png'),
	heatWheel: require('../assets/images/Journey/B2CImages/heatWheel.png'),
	leatherBelts: require('../assets/images/Journey/B2CImages/leatherBelts.png'),
	lightweightRope: require('../assets/images/Journey/B2CImages/lightweightRope.png'),
	luckyCharm: require('../assets/images/Journey/B2CImages/luckyCharm.png'),
	magicalOrb: require('../assets/images/Journey/B2CImages/magicalOrb.png'),
	magicPaint: require('../assets/images/Journey/B2CImages/magicPaint.png'),
	magicSealingWax: require('../assets/images/Journey/B2CImages/magicSealingWax.png'),
	mapCase: require('../assets/images/Journey/B2CImages/mapCase.png'),
	metalBrackets: require('../assets/images/Journey/B2CImages/metalBrackets.png'),
	mysticKnotRope: require('../assets/images/Journey/B2CImages/mysticKnotRope.png'),
	nozzlePipes: require('../assets/images/Journey/B2CImages/nozzlePipes.png'),
	protectiveOuterCoating: require('../assets/images/Journey/B2CImages/protectiveOuterCoating.png'),
	ropeNetting: require('../assets/images/Journey/B2CImages/ropeNetting.png'),
	sandbags: require('../assets/images/Journey/B2CImages/sandBags.png'),
	specialAdhesive: require('../assets/images/Journey/B2CImages/specialAdhesive.png'),
	spyglass: require('../assets/images/Journey/B2CImages/spyglass.png'),
	stitchingThread: require('../assets/images/Journey/B2CImages/stitchingThread.png'),
	supportBeams: require('../assets/images/Journey/B2CImages/supportBeams.png'),
	windDirectionRibbon: require('../assets/images/Journey/B2CImages/windDirectionRibbon.png'),
	woodenPlanks: require('../assets/images/Journey/B2CImages/woodenPlanks.png'),
};
